export default "__VITE_ASSET__BKa06rtW__"